/** Display labels for the Governed Agent Unit billing unit (short form). */
export const GAU_SINGULAR = "GAU";
export const GAU_PLURAL = "GAUs";

/** Hover tooltip copy for GauTerm. */
export const GAU_TOOLTIP_SINGULAR = "Governed Agent Unit";
export const GAU_TOOLTIP_PLURAL = "Governed Agent Units";

export function gauLabel(plural = false): string {
  return plural ? GAU_PLURAL : GAU_SINGULAR;
}

export function gauTooltip(plural = false): string {
  return plural ? GAU_TOOLTIP_PLURAL : GAU_TOOLTIP_SINGULAR;
}
